// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"order-ascending"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 19H14M3 5H12M3 12H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 7L19 4L16 7M19 19L19 5.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const OrderAscendingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'order-ascending',
    ref,
    icon: element,
  },
));

OrderAscendingIcon.displayName = 'OrderAscendingIcon';

export default OrderAscendingIcon;
